import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createSuper";
import chart from './template/echarts/echarts.vue';
import Base from './base.js';
import Vue from 'vue';
import Gikam from '../core/gikam-core';
import EcStat from 'echarts-stat';
var defaultOptions = {
  option: {},
  config: {
    dropDownMenu: [],
    search: {}
  }
};

var Echarts = /*#__PURE__*/function (_Base) {
  _inherits(Echarts, _Base);

  var _super = _createSuper(Echarts);

  function Echarts(options) {
    var _this2;

    _classCallCheck(this, Echarts);

    _this2 = _super.call(this, options);
    _this2.listeners = {
      //echarts初始化完成之后,参数为echarts对象
      ready: Gikam.emptyFunction
    };

    _this2.initialize(options, defaultOptions).init();

    return _this2;
  }

  _createClass(Echarts, [{
    key: "createViewModel",
    value: function createViewModel() {
      var _this3 = this;

      var h = this.$createElement;

      var _this = this;

      this.model = new Vue({
        el: Gikam.createDom('div', this.options.renderTo),
        render: function render() {
          var h = arguments[0];
          return h(chart, {
            "ref": "vm",
            "attrs": {
              "echartsOptions": this.options.option,
              "options": this.options.config,
              "id": this.options.id
            },
            "on": {
              "ready": function ready(myCharts, echarts) {
                _this.trigger('ready', myCharts, echarts);
              }
            }
          });
        },
        components: {
          chart: chart
        },
        data: function data() {
          return {
            options: _this.options
          };
        }
      });
      this.model.$nextTick(function () {
        _this3.bindInstance(_this3.model.$refs.vm.$el);
      });
    }
    /**
     * @description 调用echarts的setOptions方法更新图标参数
     * @public
     * @param  {} echarts的setOptions方法 原生参数
     * @memberof echarts
     */

    /* 调用echarts的setOptions方法更新图标参数 */

  }, {
    key: "setOption",
    value: function setOption(options, refreshFlag) {
      this.model.$refs.vm.setOption(options, refreshFlag);
    }
    /**
     * @description 修改组件参数
     * @public
     * @param { Object }  config 配置
     * @memberof echarts
     */

  }, {
    key: "setConfig",
    value: function setConfig(config) {
      this.options.config = Gikam.extend(true, this.options.config, config);
    }
    /**
     * @description 绑定其他三方包
     * @private
     * @param
     * @memberof echarts
     */

  }, {
    key: "bindingLibrary",
    value: function bindingLibrary() {
      this.ecStat = EcStat;
    }
  }, {
    key: "init",
    value: function init() {
      this.bindingLibrary();
      this.createViewModel();
    }
  }]);

  return Echarts;
}(Base);

export { Echarts as default };